module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "uniformity-container"
  }, [_c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticStyle: {
      "align-content": "center"
    },
    attrs: {
      "align": "end"
    }
  }, [_c('v-icon', {
    staticClass: "d-inline icon-center",
    attrs: {
      "color": "#00202F",
      "size": "1rem"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0 d-inline"
  }, [_vm._v(_vm._s(_vm.uniformityData && _vm.uniformityData.workDate ? _vm.formatDate(_vm.uniformityData.workDate) : '-'))])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [(_vm.uniformityData && _vm.uniformityData.pdfFile && _vm.uniformityData.pdfFile.url) ? _c('PdfViewer', {
    attrs: {
      "pdfUrl": _vm.uniformityData.pdfFile.url
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd3a9c40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Audits/Uniformity.vue
// module id = 1758
// module chunks = 0